import { useQuery } from 'react-query';
import { GetSessionContext } from '../apiCalls';
import { QueryKey } from './QueryKeys';

// Query for the session info.
const useSessionContext = () => {
	const { isLoading, isError, data, error } = useQuery(
		[QueryKey.GET_SESSION_CONTEXT],
		GetSessionContext,
		{ refetchOnWindowFocus: false }
	);

	const isLoggedIn = data?.resultCode === 0 && !!data?.data?.ashlinkUserId;

	const ashlinkUserId = data?.data?.ashlinkUserId || '';
	const currentPermissions = data?.data?.permissions || [];
	const userInfoData = data?.data?.userInfo || {};
	const drFedId = data?.data?.drFedId || undefined;
	const currentLinks = data?.data?.ashlinkUserRedirections || [];
	const ssId = data?.data?.ssId || '';
	const ashlinkUserType = data?.data?.ashlinkUserType || undefined;
	const ashlinkUserEntityType =
		data?.data?.ashlinkUserEntityType || undefined;
	const ashlinkUserEntityStatus =
		data?.data?.ashlinkUserEntityStatus || undefined;
	const providerId = data?.data?.providerId || undefined;
	const clinicId = data?.data?.clinicId || undefined;
	const flows = data?.data?.flows || [];
	const specialtyCode = data?.data?.specialtyCode || undefined;

	// isCompleted property keeps track of user flows
	const completedFlows = flows.map(flow => ({
		...flow,
		isCompleted: false,
	}));

	return {
		isLoading,
		isError,
		error,
		isLoggedIn,
		ashlinkUserId,
		permissions: currentPermissions,
		redirectionLinks: currentLinks,
		userInfo: userInfoData,
		drFedId,
		ashlinkUserEntityType,
		ssId,
		ashlinkUserType,
		ashlinkUserEntityStatus,
		providerId,
		clinicId,
		flows: completedFlows,
		specialtyCode,
	};
};

export default useSessionContext;
